import React from 'react'

export const BlueCheck = ({ inactive = false }) => (
  <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="https://www.w3.org/2000/svg">
    <path
      d="M16 7.81429V8.50429C15.9991 10.1216 15.4754 11.6953 14.507 12.9907C13.5386 14.286 12.1775 15.2336 10.6265 15.6922C9.07557 16.1508 7.41794 16.0957 5.90085 15.5352C4.38376 14.9747 3.08849 13.9389 2.20822 12.5821C1.32795 11.2253 0.909843 9.62034 1.01626 8.00653C1.12267 6.39271 1.7479 4.85654 2.79871 3.6271C3.84951 2.39766 5.26959 1.54083 6.84714 1.1844C8.42469 0.827975 10.0752 0.991046 11.5525 1.64929M16 2.50429L8.5 10.0118L6.25 7.76179"
      stroke={inactive ? '#B0AFAF' : '#5CB5FE'}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
